import { useState } from "react";
import { Link } from "react-router-dom";
import FAQItem from "./FAQItem";

interface FAQ {
  question: string;
  answer: string;
}

interface FAQSectionProps {
  title?: string;
  data: FAQ[];
  link: string;
}

export default function FAQSection({
  title = "IZI Care FAQs",
  data,
  link
}: FAQSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="tw-bg-white tw-py-20">
      <div className="tw-max-w-5xl tw-mx-auto tw-px-6">
        <h2 className="tw-text-3xl md:tw-text-4xl tw-font-semibold tw-text-center tw-mb-14 tw-text-black">
          {title}
        </h2>
        <div>
          {data.map((faq, index) => (
            <FAQItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
        <div className="tw-mt-20 tw-text-center">
          <Link
            to={link}
            className="tw-font-semibold hover:tw-underline tw-text-black"
          >
            Terms and Conditions
          </Link>
        </div>
      </div>
    </section>
  );
}